/* eslint-disable eqeqeq */
import {get } from 'lodash'
import Numeral from 'numeral'

export default {

    env: (state, getters) => (state.injectedEnv) ? state.injectedEnv : state.defaultEnv,

    baseUrl: (state, getters) => {
        return process.env.API_URL
    },

    style: (state, getters) => state.data.style,

    locale: (state, getters) => state.data.locale,

    text: (state, getters) => state.data.text,

    currency: (state, getters) => state.data.currency,

    iconFont: (state, getters) => state.iconFont,

    flight: (state, getters) => {
        if (state.data.flights) {
            return state.data.flights.find(flight => flight.id === state.flightId)
        }
    },

    seatCountOnRow: (state, getters) => getters.flight.seatlayout.length,

    availableSeatObjectsOnThisFlight: (state, getters) => {
        let seatObjectsByPassengers = getters.flight.passengers
            .map(passenger => passenger.seat.designator ? passenger.seat : null)
            .filter((obj) => obj)

        let baseAvailableSeats = [].concat(...getters.flight.seatmap)
            .filter(seat => seat.available === true && seat.designator !== 'AISLE')

        return baseAvailableSeats.filter(x => !seatObjectsByPassengers.includes(x))
    },

    selectedSeatsOnThisFlight: (state, getters) => {
        if (state.data.flights) {
            return getters.flight.passengers.map((passenger) => {
                return passenger.seat.designator
            })
        }
    },

    isComplete: (state, getters) => {
        let bookingTotals = getters.bookingTotals

        return bookingTotals.numSeats > 0
    },

    bookingTotals: (state, getters) => {
        let totals = { cost: 0, numSeats: 0, passengers: 0 }
        if (state.data.flights) {
            state.data.flights.forEach((flight) => {
                flight.passengers.forEach((passenger) => {
                    totals.passengers++
                        if (passenger.seat.designator !== null) {
                            totals.cost += passenger.seat.price
                            totals.numSeats++
                        }
                })
            })
        }
        return totals
    },

    flights: (state, getters) => {
        return state.data.flights.map((flight, index) => {
            return {
                'from': flight.from,
                'to': flight.to,
                'id': flight.id,
                'departure_airport': flight.departure_airport,
                'arrival_airport': flight.arrival_airport,
            }
        })
    },

    currentPassenger: (state, getters) => getters.flight.passengers.find(passenger => passenger.id === state.passengerId),

    priceMap: (state, getters) => getters.flight.pricemap,

    nextFlightId: (state, getters) => {
        let nextId = null

        let currentFlightIndex = getters.flights.findIndex(flight => flight.id === state.flightId)

        if (getters.flights.length > currentFlightIndex + 1) {
            nextId = getters.flights[currentFlightIndex + 1].id
        }

        return nextId
    },

    nextPassengerId: (state, getters) => {
        let nextId = null

        let currentPassengerIndex = getters.flight.passengers.findIndex(passenger => passenger.id === state.passengerId)

        currentPassengerIndex++

        while (nextId === null && currentPassengerIndex < getters.flight.passengers.length) {
            if (getters.flight.passengers[currentPassengerIndex].type !== 'infant') {
                nextId = getters.flight.passengers[currentPassengerIndex].id
            }
            currentPassengerIndex++
        }

        return nextId
    },

    prevPassengerId: (state, getters) => {
        let prevId = null

        let currentPassengerIndex = getters.flight.passengers.findIndex(passenger => passenger.id === state.passengerId)

        currentPassengerIndex--

        while (prevId === null && currentPassengerIndex >= 0) {
            if (getters.flight.passengers[currentPassengerIndex].type !== 'infant') {
                prevId = getters.flight.passengers[currentPassengerIndex].id
            }
            currentPassengerIndex--
        }

        return prevId
    },

    getPassengerByDesignator: (state, getters) => {
        return (designator) => {
            let selectedPassenger = ''
            getters.flight.passengers.forEach((passenger) => {
                if (passenger.seat.designator === designator) {
                    selectedPassenger = passenger.name
                }
            })
            return selectedPassenger
        }
    },

    formatCurrency: (state, getters) => {
        return (number) => {
            if (typeof state.currencyFormatter === 'function') {

                return state.currencyFormatter(number, getters.currency)
            }
            if (getters.locale == 'he' || getters.currency.code == 'GBP' || getters.currency.code == 'USD' || getters.currency.code == 'CAD') {
                return getters.currency.symbol + Numeral(number).format('0.00')
            }
            return Numeral(number).format('0.00') + getters.currency.symbol
        }
    },

    formatCentPrice: (state, getters) => {
        return (number) => {
            if (typeof state.currencyFormatter === 'function') {
                return state.currencyFormatter(number, getters.currency)
            }
            // Updated formatting to completely remove decimals
            if (getters.locale == 'he' || getters.currency.code == 'GBP' || getters.currency.code == 'USD' || getters.currency.code == 'CAD') {
                return getters.currency.symbol + Math.floor(number) // or use Numeral(number).format('0')
            }
            return Math.floor(number) + getters.currency.symbol // or use Numeral(number).format('0')
        }
    },

    isChildrenNotNextToAdultAllFlight: (state, getters) => {
        var check = true
        if (state.data.flights) {
            state.data.flights.forEach((flight) => {
                if (!getters.isChildrenNotNextToAdult(flight)) {
                    check = false
                }
            })
        }

        return check
    },

    isChildrenNotNextToAdultCurrentFlight: (state, getters) => {
        return getters.isChildrenNotNextToAdult(getters.flight)
    },

    isChildrenNotNextToAdult: (state, getters) => {
        return (flight) => {
            var check = true
            flight.passengers.forEach((passenger) => {
                if (passenger.type === 'child' && flight.should_children_seat_next_to_adult) {
                    if (passenger.seat.designator != null) {
                        [...flight.seatmap].forEach((seatColumn) => {
                            let indexColumn = seatColumn.findIndex(seat => passenger.seat.designator === seat.designator)
                            if (indexColumn !== -1) {
                                let nearPassengerDesignators = []
                                for (let i = indexColumn - 1; i >= 0; i--) {
                                    if (flight.passengers.map(passenger => passenger.seat.designator).includes(seatColumn[i].designator)) {
                                        nearPassengerDesignators.push(seatColumn[i].designator)
                                    } else if (!seatColumn[i].aisle) {
                                        break
                                    }
                                }
                                for (let i = indexColumn + 1; i < seatColumn.length; i++) {
                                    if (flight.passengers.map(passenger => passenger.seat.designator).includes(seatColumn[i].designator)) {
                                        nearPassengerDesignators.push(seatColumn[i].designator)
                                    } else if (!seatColumn[i].aisle) {
                                        break
                                    }
                                }
                                let adultsNearChild = flight.passengers
                                    .filter(adultPassenger => adultPassenger.type === 'adult' && nearPassengerDesignators.includes(adultPassenger.seat.designator))

                                if (adultsNearChild.length === 0) {
                                    check = false
                                }
                            }
                        })
                    }
                }
            })

            return check
        }
    },

    areSeatsSelectedAllFlight: (state, getters) => {
        var check = true

        if (state.data.flights) {
            state.data.flights.forEach((flight) => {
                if (!getters.areSeatsSelected(flight)) {
                    check = false
                }
            })
        }

        return check
    },

    areSeatsSelectedCurrentFlight: (state, getters) => {
        return getters.areSeatsSelected(getters.flight)
    },

    areSeatsSelected: (state, getters) => {
        return (flight) => {
            var check = true
            if (flight.requires_all_seats_selected) {
                var hasSelectedOneSeat = false
                var hasUnassignedSeat = false
                flight.passengers.forEach((passenger) => {
                    if (passenger.type !== 'infant') {
                        if (passenger.seat.designator != null) {
                            hasSelectedOneSeat = true
                        } else {
                            hasUnassignedSeat = true
                        }
                    }
                })

                if (hasSelectedOneSeat && hasUnassignedSeat) {
                    check = false
                }
            }
            return check
        }
    }
}


// WEBPACK FOOTER //
// ./src/data/getters.js